import React from "react";
import "./index.scss";
import { Main, Navigation, EngineeringProjects, Project, Timeline, Expertise, Contact, Footer } from "./components";
function App() {
  return (
    <div className="main-container light-mode">
      <Navigation />
      <Main />
      <Expertise />
      <EngineeringProjects />
      <Timeline />
      <Project />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
